var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-textarea',{attrs:{"aria-live":"off","placeholder":_vm.$t('questionInputPlaceholder'),"name":"freeText"},on:{"input":_vm.onInput},model:{value:(_vm.answerValue),callback:function ($$v) {_vm.answerValue=$$v},expression:"answerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }